/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Overrides_Auto_TitleInputs */

const fr_style_overrides_auto_title = /** @type {(inputs: Style_Overrides_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montage automatique`)
};

const en_style_overrides_auto_title = /** @type {(inputs: Style_Overrides_Auto_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto mount`)
};

/**
* | output |
* | --- |
* | "Auto mount" |
*
* @param {Style_Overrides_Auto_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const style_overrides_auto_title = /** @type {((inputs?: Style_Overrides_Auto_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Overrides_Auto_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_overrides_auto_title(inputs)
	return en_style_overrides_auto_title(inputs)
});